import { Camera } from '@capacitor/camera'
import { Capacitor } from '@capacitor/core'
import { Geolocation } from '@capacitor/geolocation'
import { SplashScreen } from '@capacitor/splash-screen'
import { StatusBar } from '@capacitor/status-bar'
import { AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency'

/**
 * This boot file provides Capacitor functionality to the app
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default async ({ app }) => {
  // Check if the app is running in a Capacitor native context
  const isCapacitor = Capacitor.isNativePlatform()
  const isIOS = Capacitor.getPlatform() === 'ios'
  const isAndroid = Capacitor.getPlatform() === 'android'

  // Only proceed with adapter if we're running in a Capacitor context
  if (!isCapacitor) return

  // Add platform-specific classes to html and body elements
  if (isCapacitor) {
    document.documentElement.classList.add('capacitor')
    document.body.classList.add('capacitor')

    if (isIOS) {
      document.documentElement.classList.add('capacitor-ios')
      document.body.classList.add('capacitor-ios')
    } else if (isAndroid) {
      document.documentElement.classList.add('capacitor-android')
      document.body.classList.add('capacitor-android')
    }
  }

  // Make Capacitor available to the app
  app.config.globalProperties.$capacitor = {
    isCapacitor,
    isIOS,
    isAndroid,
    camera: Camera,
    geolocation: Geolocation,
    splashScreen: SplashScreen,
    statusBar: StatusBar,
    appTrackingTransparency: AppTrackingTransparency
  }
}
